import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartLine',
  props: {
    value: Object,
    text: String,
    lineName: String,
    subtext: String,
    legend: Array,
    series: Array,
    xAxis: Array
  },
  data: function data() {
    return {
      dom: null,
      option: {},
      index: 0
    };
  },
  watch: {
    series: {
      handler: function handler(newVal, oldVal) {
        if (this.dom) {
          if (newVal) {
            this.getDataInit();
          } else {
            this.getDataInit();
          }
        } else {
          this.init();
        }
      },
      deep: true
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setOption: function setOption() {
      var legendSelect = {};

      for (var i in this.legend) {
        if (i === '0') {
          legendSelect[this.legend[i]] = true;
        } else {
          legendSelect[this.legend[i]] = false;
        }
      }

      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: legendSelect,
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = params[0].seriesName;

            for (var _i in params) {
              var str = params[_i].value ? '在线' : '离线';
              result += '<br/>' + params[_i].name + ':' + str;
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[0].xaxis : [] // axisLabel:{
          //   interval:0,
          //   rotate:40
          // }

        },
        yAxis: {
          type: 'value',
          data: ['在线', '离线'],
          max: 1,
          min: 0,
          axisLabel: {
            formatter: function formatter(value) {
              var reuslt = [];

              if (value === 1) {
                reuslt.push('在线');
              } else if (value === 0) {
                reuslt.push('离线');
              }

              return reuslt;
            }
          }
        },
        series: this.series
      };
      return option;
    },
    //高温与还原
    setOption1: function setOption1() {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: {
            '在线离线': false,
            '高温/恢复': true,
            '电量趋势': false,
            '维保': false
          },
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = params[0].seriesName;

            for (var i in params) {
              var str = params[i].value ? '高温' : '恢复';
              result += '<br/>' + params[i].name + ':' + str;
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[1].xaxis : [] // axisLabel:{
          //   interval:0,
          //   rotate:40
          // }

        },
        yAxis: {
          type: 'value',
          data: ['高温', '恢复'],
          max: 1,
          min: 0,
          axisLabel: {
            formatter: function formatter(value) {
              var reuslt = [];

              if (value === 1) {
                reuslt.push('高温');
              } else if (value === 0) {
                reuslt.push('恢复');
              }

              return reuslt;
            }
          }
        },
        series: this.series
      };
      return option;
    },
    setOption2: function setOption2() {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: {
            '在线离线': false,
            '高温/恢复': false,
            '电量趋势': true,
            '维保': false
          },
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = params[0].seriesName;

            for (var i in params) {
              var str = params[i].value;
              result += '<br/>' + params[i].name + ':电量 ' + str + '%';
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[2].xaxis : [] // axisLabel:{
          //   interval:0,
          //   rotate:40
          // }

        },
        yAxis: {
          type: 'value',
          max: 100,
          min: 0,
          axisLabel: {
            formatter: '{value} %'
          }
        },
        series: this.series
      };
      return option;
    },
    setOption3: function setOption3() {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: {
            '在线离线': false,
            '高温/恢复': false,
            '电量趋势': false,
            '维保': true
          },
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = params[0].seriesName;

            for (var i in params) {
              var str = params[i].value ? '维保' : '正常';
              result += '<br/>' + params[i].name + ':' + str;
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[3].xaxis : [] // axisLabel:{
          //   interval:0,
          //   rotate:40
          // }

        },
        yAxis: {
          type: 'value',
          data: ['维保', '正常'],
          max: 1,
          min: 0,
          axisLabel: {
            formatter: function formatter(value) {
              var reuslt = [];

              if (value === 1) {
                reuslt.push('维保');
              } else if (value === 0) {
                reuslt.push('正常'); // reuslt='正常'
              }

              return reuslt;
            }
          }
        },
        series: this.series
      };
      return option;
    },
    getDataInit: function getDataInit() {
      var index = this.index;

      if (index === 0) {
        this.dom.setOption(this.setOption());
      } else if (index === 1) {
        this.dom.setOption(this.setOption1());
      } else if (index === 2) {
        this.dom.setOption(this.setOption2());
      } else if (index === 3) {
        this.dom.setOption(this.setOption3());
      } else {
        this.dom.setOption(this.setOption());
      }
    },
    init: function init() {
      var _this = this;

      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.showLoading();
      this.dom.setOption(this.setOption());
      this.dom.hideLoading();
      this.dom.on('legendselectchanged', function (res) {
        var index = _this.legend.indexOf(res.name);

        _this.index = index;

        if (index === 0) {
          _this.dom.setOption(_this.setOption());
        } else if (index === 1) {
          _this.dom.setOption(_this.setOption1());
        } else if (index === 2) {
          _this.dom.setOption(_this.setOption2());
        } else if (index === 3) {
          _this.dom.setOption(_this.setOption3());
        }
      });
      on(window, 'resize', this.resize);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};